<template lang="pug">
  background
    coach-detail-message(:coach="coach")
    coach-detail-review-summary(v-if="coach.reviewCount" :coach="coach")
    coach-detail-reviews(
      v-if="coach.reviews"
      :reviews="coach.reviews"
      @click="$emit('click', $event)")
    coach-detail-profile(:coach="coach")
    coach-detail-gallery(:coach="coach")
</template>

<style lang="scss" scoped>
.coach-detail-message,
.coach-detail-profile,
.coach-detail-gallery {
  margin-top: 24px;
  padding: 0 16px 16px;
}
.coach-detail-review-summary {
  margin-top: 24px;
  padding-left: 24px;
}
.coach-detail-reviews {
  margin-top: 12px;
  padding-bottom: 16px;
}
</style>

<script>
import CoachDetailMessage from '@/components/molecules/CoachDetailMessage'
import CoachDetailProfile from '@/components/molecules/CoachDetailProfile'
import CoachDetailReviewSummary from '@/components/molecules/CoachDetailReviewSummary'
import CoachDetailReviews from '@/components/molecules/CoachDetailReviews'
import CoachDetailGallery from '@/components/molecules/CoachDetailGallery'

export default {
  components: {
    CoachDetailMessage,
    CoachDetailProfile,
    CoachDetailReviewSummary,
    CoachDetailReviews,
    CoachDetailGallery,
  },
  props: {
    coach: {
      type: Object,
      required: true,
    },
  },
}
</script>
